// extracted by mini-css-extract-plugin
export var btn = "components-modals-__SessionTimeout-module___btn";
export var modalWrapper = "components-modals-__SessionTimeout-module___modalWrapper";
export var overlay = "components-modals-__SessionTimeout-module___overlay";
export var time = "components-modals-__SessionTimeout-module___time";